import { Box, Skeleton } from '@packages/shared';

export const AddedProductLoadingFallback = () => (
  <Box sx={{ display: 'flex', gap: 2 }}>
    <Skeleton variant="rectangular" width={120} height={120} />
    <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', gap: 2.5 }}>
      <Skeleton variant="rectangular" width="100%" height="20px" />
      <Skeleton variant="rectangular" width="100%" height="20px" />
      <Skeleton variant="rectangular" width="120px" height="20px" />
      <Skeleton variant="rectangular" width="120px" height="20px" />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignSelf: 'flex-end' }}>
        <Skeleton variant="rectangular" width="100px" height="20px" />
        <Skeleton variant="rectangular" width="100px" height="20px" />
      </Box>
    </Box>
  </Box>
);
